module.exports = __webpack_public_path__ + "img/game_glive.bbddae3.webp";